import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=8128706e&scoped=true&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"
import style0 from "./JobItem.vue?vue&type=style&index=0&id=8128706e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8128706e",
  null
  
)

export default component.exports